import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
export class SingleVehicleManufacturerStore {
    constructor(vehicleManufacturerService) {
        this.vehicleManufacturerService = vehicleManufacturerService;
        this.vehicleManufacturer = null;
        this.loading = false;
        makeAutoObservable(this);
    }
    setVehicleManufacturer(vehicleManufacturer) {
        this.vehicleManufacturer = vehicleManufacturer;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async init(vehicleManufacturerId) {
        this.setLoading(true);
        try {
            const vehicleManufacturers = vehicleManufacturerId
                ? await this.vehicleManufacturerService.getVehicleManufacturersByIds([vehicleManufacturerId])
                : null;
            this.setVehicleManufacturer(vehicleManufacturers?.[0] || null);
        }
        catch (error) {
            onError(error, "Error initializing vehicle manufacturer");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveVehicleManufacturer(vehicleManufacturerData) {
        try {
            this.setLoading(true);
            const task = this.vehicleManufacturer
                ? this.vehicleManufacturerService.updateVehicleManufacturer(this.vehicleManufacturer.id, vehicleManufacturerData)
                : this.vehicleManufacturerService.createVehicleManufacturer(vehicleManufacturerData);
            this.setVehicleManufacturer(await task);
            return this.vehicleManufacturer;
        }
        catch (error) {
            onError(error, "Error saving vehicle manufacturer");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async deleteVehicleManufacturer(vehicleManufacturerId) {
        this.setLoading(true);
        try {
            await this.vehicleManufacturerService.deleteVehicleManufacturer(vehicleManufacturerId);
            this.setVehicleManufacturer(null);
        }
        catch (error) {
            onError(error, "Failed to delete vehicle manufacturer");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearVehicleManufacturerData() {
        this.setVehicleManufacturer(null);
        this.setLoading(false);
    }
}
